import { useMemo } from 'react';
import { useSeriesColor } from './useSeriesColor';

type HistChartDataset = {
  x: number[];
  series: { label: string; y: number[] }[];
};

export const useHistChartParams = ({ x, series }: HistChartDataset) => {
  const bars = useMemo(() => {
    return series.map((dataItem) => ({
      label: dataItem.label,
      data: dataItem.y.map((value, index) => {
        const label = x[index + 1] === undefined ? `${x[index]}+` : `${x[index]} - ${x[index + 1]}`;
        return [label, value] as [string, number];
      }),
    }));
  }, [series, x]);

  const colorSet = useSeriesColor(series);

  return { bars, colorSet };
};
